import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import clsx from "clsx";
import Breadcrumb from "../../Common/Breadcrumb";
import { createServicePlan } from "../../../models/_servicePlan";
import { IconPicker } from 'react-fa-icon-picker'

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
});

function CreateServicePlan() {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
          style={{ maxWidth: "100%" }}
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap">
            <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
              Create Service Plans
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
            <Breadcrumb
              links={[
                { label: "Home", href: "/dashboard", isActive: false },
                { label: "Create Service Plans", href: "", isActive: true },
              ]}
            />
          </div>
        </div>
      </div>

      <div className="card mx-xl-4 mt-9">
        <Formik
          initialValues={{
            name: "",
            description: "",
            indicater: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            setLoading(true);
            let $inputData: any = {
              name: values.name,
              description: values.description,
              indicater: values.indicater,
            };

            const result = await createServicePlan($inputData);
            if (result?.data?.data?.createServicePlan) {
              toast.success("Service Plans successfully");
              setSubmitting(false);
              setLoading(false);
              resetForm();
            } else {
              setSubmitting(false);
              setLoading(false);
              const messages = result?.data?.errors.map((e: any) => e.message);
              toast.error(messages.join(","));
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 required fw-bold">
                      Name
                    </label>
                    <input
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.name) && touched.name,
                      })}
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="name" />
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4  fw-bold">
                      Description
                    </label>
                    <textarea
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.description) && touched.description,
                      })}
                      name="description"
                      id="description"
                      value={values.description}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="description" />
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 fw-bold">
                      Indicater
                    </label>
                    <div className="position-relative">
                      <IconPicker
                        value={values.indicater}
                        onChange={(v: any) => setFieldValue("indicater", v)}
                        containerStyles={{
                          border: "1px solid #e4e6ef",
                          borderRadius: "0.375rem",
                          padding: "0.5rem",
                          width: "100%",
                          backgroundColor: "#ffffff",
                        }}
                        buttonStyles={{
                          border: "1px solid #e4e6ef",
                          borderRadius: "0.375rem",
                          padding: "0.375rem 0.75rem",
                          width: "100%",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: "#495057",
                          backgroundColor: "#ffffff",
                        }}
                        iconStyles={{
                          fontSize: "1.25rem",
                          marginRight: "0.5rem",
                        }}
                      />
                      {values.indicater && (
                        <span
                          className="position-absolute top-50 end-0 translate-middle-y me-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => setFieldValue("indicater", "")}
                        >
                          <i className="fa fa-times" style={{ fontSize: "1.25rem", color: "#000" }}></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 px-xl-5 p-2">
                    <button
                      type="submit"
                      className="btn btn-primary me-4 fs-4 w-100"
                    >
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please Wait..
                          <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label">ADD Service Plan</span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>

        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </div>
    </div>
  );
}

export default CreateServicePlan;
